import { time } from '@motionone/utils';
import { defaults } from './defaults.es.js';
import { calcDampingRatio } from './utils.es.js';
import { hasReachedTarget } from '../utils/has-reached-target.es.js';
import { calcGeneratorVelocity } from '../utils/velocity.es.js';
var spring = function spring() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$stiffness = _ref.stiffness,
    stiffness = _ref$stiffness === void 0 ? defaults.stiffness : _ref$stiffness,
    _ref$damping = _ref.damping,
    damping = _ref$damping === void 0 ? defaults.damping : _ref$damping,
    _ref$mass = _ref.mass,
    mass = _ref$mass === void 0 ? defaults.mass : _ref$mass,
    _ref$from = _ref.from,
    from = _ref$from === void 0 ? 0 : _ref$from,
    _ref$to = _ref.to,
    to = _ref$to === void 0 ? 1 : _ref$to,
    _ref$velocity = _ref.velocity,
    velocity = _ref$velocity === void 0 ? 0.0 : _ref$velocity,
    restSpeed = _ref.restSpeed,
    restDistance = _ref.restDistance;
  velocity = velocity ? time.s(velocity) : 0.0;
  var state = {
    done: false,
    hasReachedTarget: false,
    current: from,
    target: to
  };
  var initialDelta = to - from;
  var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
  var dampingRatio = calcDampingRatio(stiffness, damping, mass);
  var isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
  restDistance || (restDistance = isGranularScale ? 0.005 : 0.5);
  var resolveSpring;
  if (dampingRatio < 1) {
    var angularFreq = undampedAngularFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
    // Underdamped spring (bouncy)
    resolveSpring = function resolveSpring(t) {
      return to - Math.exp(-dampingRatio * undampedAngularFreq * t) * ((-velocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
    };
  } else {
    // Critically damped spring
    resolveSpring = function resolveSpring(t) {
      return to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (-velocity + undampedAngularFreq * initialDelta) * t);
    };
  }
  return function (t) {
    state.current = resolveSpring(t);
    var currentVelocity = t === 0 ? velocity : calcGeneratorVelocity(resolveSpring, t, state.current);
    var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
    var isBelowDisplacementThreshold = Math.abs(to - state.current) <= restDistance;
    state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
    state.hasReachedTarget = hasReachedTarget(from, to, state.current);
    return state;
  };
};
export { spring };